import {Component, OnInit} from '@angular/core';
import {SharedDataService} from "../service/shared-data.service";
import {KlasifikatoriusService} from "../service/klasifikatorius.service";
import {TabakoKlasifikatoriusApi} from "../api/tabako-klasifikatorius.api";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {cancelIcon, plusIcon, trashIcon} from '@progress/kendo-svg-icons';
import {
  AddEvent,
  CancelEvent,
  CellClickEvent,
  CellCloseEvent,
  GridComponent,
  RemoveEvent,
  SaveEvent
} from "@progress/kendo-angular-grid";
import {Keys} from "@progress/kendo-angular-common";
import {KlasifikatoriusEditService} from "../service/klasifikatorius-edit.service";
import {Observable, of} from "rxjs";
import {KlasifikatoriusApi} from "../api/klasifikatorius.api";
import {KlasifikatoriausReiksmeApi} from "../api/klasifikatoriaus-reiksme.api";

@Component({
  selector: 'app-klasifikatorius',
  styleUrl: './klasifikatorius.component.css',
  template: `
    <div class="vid-reg-forma-style"  *ngIf="!sharedDataService.getKlaidos()">
      <label class="title" style="padding-bottom: 10px">{{ 'title.tabako.klasifikatorius' | translate }}</label>
      <kendo-grid #grid
                  [data]="klasifikatoriausReiksme$ | async"
                  (cellClick)="cellClickHandler($event)"
                  (cellClose)="cellCloseHandler($event)"
                  (cancel)="cancelHandler($event)"
                  (add)="addHandler($event)"
                  (save)="saveHandler($event)"
                  (remove)="removeHandler($event)"
                  [loading]="klasifikatoriusEditService.loading"
                  [class]="'selectable-grid'"
                  [navigable]="true"
                  [sortable]="true">
        <ng-template kendoGridToolbarTemplate>
          <button kendoGridAddCommand themeColor="primary">
            {{ 'button.prideti.nauja' | translate }}
          </button>
          <button kendoButton themeColor="primary" fillMode="outline"
            [disabled]="!klasifikatoriusEditService.hasChanges()"
            (click)="saveChanges(grid)">
            {{ 'button.issaugoti.pakeitimus' | translate }}
          </button>
          <button kendoButton themeColor="error" fillMode="outline"
            (click)="cancelChanges(grid)"
            [disabled]="!klasifikatoriusEditService.hasChanges()">
            {{ 'button.atsaukti.pakeitimus' | translate }}
          </button>
        </ng-template>
        <kendo-grid-column field="kodas" title="{{ 'grid.title.kodas' | translate }}" [width]="10">
          <kendo-formerror>
            {{ 'validator.asm.vardas.pavarde.required' | translate }}
          </kendo-formerror>
        </kendo-grid-column>
        <kendo-grid-column field="cldvlId" title="{{ 'grid.title.tevas' | translate }}" [width]="10">
          <ng-template
            kendoGridEditTemplate
            let-dataItem="dataItem"
            let-formGroup="formGroup"
          >
            <kendo-dropdownlist
              [defaultItem]="{ id: null, kodas: ''}"
              [data]="dropdownItems"
              textField="kodas"
              valueField="id"
              [valuePrimitive]="true"
              [formControl]="formGroup.get('cldvlId')"
              (open)="onDropDownOpen($event, dataItem)"
              (selectionChange)="onSelectionChanged($event, dataItem)">
              <ng-template kendoDropDownListNoDataTemplate>
                {{ 'label.duomenu.nera' | translate }}
              </ng-template>
            </kendo-dropdownlist>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ getKodasForId(dataItem.cldvlId) }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="pavadinimas" title="{{ 'grid.title.pavadinimas' | translate }}" [width]="25">
        </kendo-grid-column>
        <kendo-grid-column field="pilnasPavadinimas" title="{{ 'grid.title.pilnas.pavadinimas' | translate }}" [width]="15">
        </kendo-grid-column>
        <kendo-grid-column field="pavadinimasEn" title="{{ 'grid.title.pavadinimas.en' | translate }}" [width]="25">
        </kendo-grid-column>
        <kendo-grid-column field="pilnasPavadinimasEn" title="{{ 'grid.title.pilnas.pavadinimas.en' | translate }}" [width]="18">
        </kendo-grid-column>
        <kendo-grid-column editor="numeric" field="filtroSvoris" title="{{ 'grid.title.filto.svoris' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.filtroSvoris | number: '1.6-6' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column editor="date" field="dateFrom" [format]="'yyyy-MM-dd'" title="{{ 'grid.title.galioja.nuo' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.dateFrom | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column editor="date" field="dateTo" title="{{ 'grid.title.galioja.iki' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.dateTo | date: 'yyyy-MM-dd'}}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="pastaba" title="{{ 'grid.title.pastaba' | translate }}" [width]="12">
        </kendo-grid-column>
        <kendo-grid-command-column [width]="10">
          <ng-template kendoGridCellTemplate let-isNew="isNew">
            <div class="button-container">
              <button kendoGridRemoveCommand themeColor="error" fillMode="outline" style="width: 100%">
                <kendo-svg-icon [icon]="icons.trashIcon"></kendo-svg-icon>
              </button>
              <button kendoGridSaveCommand themeColor="primary" class="button-spacing">
                <kendo-svg-icon [icon]="icons.plusIcon"></kendo-svg-icon>
              </button>
              <button kendoGridCancelCommand themeColor="error" class="button-spacing">
                <kendo-svg-icon [icon]="icons.cancelIcon"></kendo-svg-icon>
              </button>
            </div>
          </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-messages
          [noRecords]="'label.sarasas.tuscias' | translate"
        >
        </kendo-grid-messages>
      </kendo-grid>
    </div>
    <div *ngIf="sharedDataService.getKlaidos()" class="error-message-red">
      {{ this.sharedDataService.getKlaidos() | translate}}
    </div>
  `,
})
export class KlasifikatoriusComponent implements OnInit {

  klasifikatoriausReiksme$!: Observable<TabakoKlasifikatoriusApi[]>;
  public formGroup!: FormGroup;
  public icons = { trashIcon: trashIcon, plusIcon: plusIcon, cancelIcon: cancelIcon };
  klasifikatorius: any[] = [];
  dropdownItems: any[] = [];
  selectedItems: { kodas: string, tevas: string }[] = [];

  constructor(public sharedDataService: SharedDataService,
              private klasifikatoriusService: KlasifikatoriusService,
              public klasifikatoriusEditService: KlasifikatoriusEditService,
              private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.selectedItems = [];
    this.klasifikatoriusEditService.getKlasifikatoriausData().subscribe(data => {
      this.klasifikatoriausReiksme$ = of(data);
    });

    this.sharedDataService.getklasifikatoriusApiSubject().subscribe((data: KlasifikatoriusApi[]) => {
      this.klasifikatorius = (
        data
          ?.find((x: KlasifikatoriusApi) => x.kodas === 'CL164')
          ?.klasifikatoriausReiksmeApiList
          ?.map((item: KlasifikatoriausReiksmeApi) => ({id: item.id, kodas: item.kodas, tevas: item.cldvlId}))
      ) || [];
    });

    this.klasifikatoriusEditService.read();
  }

  onDropDownOpen(event: any, dataItem: any): void {
    if (dataItem.id != null) {
      const hasChildren = this.klasifikatorius.some(item => item.tevas === dataItem.id);
      const kodasExistsInSelectedItems = this.selectedItems.some(selectedItem => selectedItem.tevas === dataItem.kodas);
      if (dataItem.id === null) {
        this.dropdownItems = this.klasifikatorius.filter(item => item.tevas === null)
      } else if (hasChildren || kodasExistsInSelectedItems) {
        this.dropdownItems = [];
      } else {
        this.dropdownItems = this.klasifikatorius.filter(item => item.id !== dataItem.id &&
          !this.selectedItems.some(selectedItem => selectedItem.kodas === item.kodas) && item.tevas === null);
      }
    } else {
      this.dropdownItems = [];
    }
  }

  onSelectionChanged(event: any, dataItem: any): void {
    if (event.kodas !== '') {
      if (this.selectedItems.some(selectedItem => selectedItem.kodas === dataItem.kodas)) {
        this.selectedItems = this.selectedItems.filter(selectedItem =>
          selectedItem.kodas !== dataItem.kodas
        );
      }
      this.selectedItems.push({ kodas: dataItem.kodas, tevas: event.kodas });
    } else {
      this.selectedItems = this.selectedItems.filter(selectedItem =>
        selectedItem.kodas !== dataItem.kodas
      );
    }
  }


  getKodasForId(cldvlId: string): string {
    const item = this.klasifikatorius.find(item => item.id === cldvlId);
    return item ? item.kodas : '';
  }

  public cellClickHandler(args: CellClickEvent): void {
    if (!args.isEdited) {
      args.sender.editCell(
        args.rowIndex,
        args.columnIndex,
        this.createFormGroup(args.dataItem)
      );
    }
  }

  public cellCloseHandler(args: CellCloseEvent): void {
    const { formGroup, dataItem } = args;

    if (!formGroup.valid) {
      args.preventDefault();
    } else if (formGroup.dirty) {
      if (args.originalEvent && args.originalEvent.keyCode === Keys.Escape) {
        return;
      }

      this.klasifikatoriusEditService.assignValues(dataItem, formGroup.value);
      this.klasifikatoriusEditService.update(dataItem);
    }
  }

  public addHandler(args: AddEvent): void {
    args.sender.addRow(this.createFormGroup(new TabakoKlasifikatoriusApi()));
  }

  public createFormGroup(dataItem: TabakoKlasifikatoriusApi): FormGroup {
    return this.formBuilder.group({
      id: dataItem.id,
      kodas: [dataItem.kodas, Validators.required],
      cldvlId: dataItem.cldvlId,
      pavadinimas: [dataItem.pavadinimas, Validators.required],
      pilnasPavadinimas: dataItem.pilnasPavadinimas,
      pavadinimasEn: [dataItem.pavadinimasEn, Validators.required],
      pilnasPavadinimasEn: dataItem.pilnasPavadinimasEn,
      filtroSvoris: [
        dataItem.filtroSvoris,
        Validators.compose([
          Validators.required,
          Validators.pattern("^\\d+([,.]\\d{0,6})?$"),
        ]),
      ],
      dateFrom: [dataItem.dateFrom != null ? new Date(dataItem.dateFrom) : dataItem.dateFrom, Validators.required],
      dateTo: dataItem.dateTo != null ? new Date(dataItem.dateTo): dataItem.dateTo,
      pastaba: dataItem.pastaba
    });
  }

  public cancelHandler(args: CancelEvent): void {
    args.sender.closeRow(args.rowIndex);
  }

  public saveHandler(args: SaveEvent): void {
    if (args.formGroup.valid) {
      this.klasifikatoriusEditService.create(args.formGroup.value);
      args.sender.closeRow(args.rowIndex);
    } else {
      args.formGroup.markAllAsTouched();
    }
  }

  public removeHandler(args: RemoveEvent): void {
    this.klasifikatoriusEditService.remove(args.dataItem);

    args.sender.cancelCell();
  }

  public saveChanges(grid: GridComponent): void {
    grid.closeCell();
    grid.cancelCell();

    this.klasifikatoriusEditService.saveChanges();
    this.selectedItems = [];
  }

  public cancelChanges(grid: GridComponent): void {
    grid.cancelCell();
    this.selectedItems = [];

    this.klasifikatoriusEditService.cancelChanges();
  }

}
